import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { objectsSlice } from "../app/reduxSlices/objectsSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  users: objectsSlice({ name: "users" }).reducer,
  golestanUsers: objectsSlice({ name: "golestanUsers" }).reducer,

  univercities: objectsSlice({ name: "univercities" }).reducer,
  buildings: objectsSlice({ name: "buildings" }).reducer,
  floors: objectsSlice({ name: "floors" }).reducer,
  rooms: objectsSlice({ name: "rooms" }).reducer,
  provinces: objectsSlice({ name: "provinces" }).reducer,
  towns: objectsSlice({ name: "towns" }).reducer,
  groups: objectsSlice({ name: "groups" }).reducer,
  subGroups: objectsSlice({ name: "subGroups" }).reducer,
  auditListForms: objectsSlice({ name: "auditListForms" }).reducer,
  auditList: objectsSlice({ name: "auditList" }).reducer,
  terms: objectsSlice({ name: "terms" }).reducer,
  years: objectsSlice({ name: "years" }).reducer,
  semesters: objectsSlice({ name: "semesters" }).reducer,
  grades: objectsSlice({ name: "grades" }).reducer,
  places: objectsSlice({ name: "places" }).reducer,
  seats: objectsSlice({ name: "seats" }).reducer,

  categories: objectsSlice({ name: "categories" }).reducer,
  parentCategories: objectsSlice({ name: "parentCategories" }).reducer,
  placeCategories: objectsSlice({ name: "placeCategories" }).reducer,
  buildingCategories: objectsSlice({ name: "buildingCategories" }).reducer,
  roomCategories: objectsSlice({ name: "roomCategories" }).reducer,
  seatCategories: objectsSlice({ name: "seatCategories" }).reducer,
  baseCategories: objectsSlice({ name: "baseCategories" }).reducer,
  genderCategories: objectsSlice({ name: "genderCategories" }).reducer,

  auditPeriods: objectsSlice({ name: "auditPeriods" }).reducer,
  formTypes: objectsSlice({ name: "formTypes" }).reducer,
  forms: objectsSlice({ name: "forms" }).reducer,
  questions: objectsSlice({ name: "questions" }).reducer,
  answers: objectsSlice({ name: "answers" }).reducer,
  answerQuestions: objectsSlice({ name: "answerQuestions" }).reducer,
  auditPeriodOptions: objectsSlice({ name: "auditPeriodOptions" }).reducer,

  auditPlaceBuildings: objectsSlice({ name: "auditPlaceBuildings" }).reducer,
  auditPlaces: objectsSlice({ name: "auditPlaces" }).reducer,
  auditFormTypes: objectsSlice({ name: "auditFormTypes" }).reducer,
  auditBuildings: objectsSlice({ name: "auditBuildings" }).reducer,

  auditFormResults: objectsSlice({ name: "auditFormResults" }).reducer,
  placeAuditFormList: objectsSlice({ name: "placeAuditFormList" }).reducer,
  buildingAuditFormList: objectsSlice({ name: "buildingAuditFormList" }).reducer,
  floorAuditFormList: objectsSlice({ name: "floorAuditFormList" }).reducer,
  roomAuditFormList: objectsSlice({ name: "roomAuditFormList" }).reducer,
  seatAuditFormList: objectsSlice({ name: "seatAuditFormList" }).reducer,
  placeAuditFormResults: objectsSlice({ name: "placeAuditFormResults" }).reducer,
  buildingAuditFormResults: objectsSlice({ name: "buildingAuditFormResults" }).reducer,
  floorAuditFormResults: objectsSlice({ name: "floorAuditFormResults" }).reducer,
  roomAuditFormResults: objectsSlice({ name: "roomAuditFormResults" }).reducer,
  seatAuditFormResults: objectsSlice({ name: "seatAuditFormResults" }).reducer,

  floorReports: objectsSlice({ name: "floorReports" }).reducer,


  filterQuestions: objectsSlice({ name: "filterQuestions" }).reducer,
  filterAnswers: objectsSlice({ name: "filterAnswers" }).reducer,

  countryAuditFormReports: objectsSlice({ name: "countryAuditFormReports" }).reducer,
  placeAuditFormReports: objectsSlice({ name: "placeAuditFormReports" }).reducer,
  buildingAuditFormReports: objectsSlice({ name: "buildingAuditFormReports" }).reducer,
  provienceAuditFormReports: objectsSlice({ name: "provienceAuditFormReports" }).reducer,
  townAuditFormReports: objectsSlice({ name: "townAuditFormReports" }).reducer,



  detailAuditFormReports: objectsSlice({ name: "detailAuditFormReports" }).reducer,

  countryBuildingReports: objectsSlice({ name: "countryBuildingReports" }).reducer,
  placeBuildingReports: objectsSlice({ name: "placeBuildingReports" }).reducer,
  provienceBuildingReports: objectsSlice({ name: "provienceBuildingReports" }).reducer,

  auditQuestions: objectsSlice({ name: "auditQuestions" }).reducer,
  auditListPlaces: objectsSlice({ name: "auditListPlaces" }).reducer,
  auditFormQuestions: objectsSlice({ name: "auditFormQuestions" }).reducer,
  auditListFormResults: objectsSlice({ name: "auditListFormResults" }).reducer,

  calendars: objectsSlice({ name: "calendars" }).reducer,
  roles: objectsSlice({ name: "roles" }).reducer,
  menus: objectsSlice({ name: "menus" }).reducer,
  permissions: objectsSlice({ name: "permissions" }).reducer,
  groupPermissions: objectsSlice({ name: "groupPermissions" }).reducer,
  menuPermissions: objectsSlice({ name: "menuPermissions" }).reducer,
  rolePermissions: objectsSlice({ name: "rolePermissions" }).reducer,
  placePermissions: objectsSlice({ name: "placePermissions" }).reducer,
  // formTypePermissions: objectsSlice({ name: "formTypePermissions" }).reducer,
  // auditPlacePermissions: objectsSlice({ name: "auditPlacePermissions" }).reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
